const DIRECT_LOGIN_START = "WFP_DIRECT_LOGIN_START";
const DIRECT_LOGIN_DONE = "WFP_DIRECT_LOGIN_DONE";
const DIRECT_LOGIN_ERROR = "WFP_DIRECT_LOGIN_ERROR"; 

const GET_DIRECT_LOGIN_RESULT_START = "WFP_GET_DIRECT_LOGIN_RESULT_START";
const GET_DIRECT_LOGIN_RESULT_DONE = "WFP_GET_DIRECT_LOGIN_RESULT_DONE";
const GET_DIRECT_LOGIN_RESULT_ERROR = "WFP_GET_DIRECT_LOGIN_RESULT_ERROR"; 

const SET_USEEME = "WFP_SET_USEEME";
const SET_IS_USING_APP_LOGIN = "WFP_SET_IS_USING_APP_LOGIN";

const SET_EMEFIELD_EDITED = 'WFP_SET_EMEFIELD_EDITED';
const SET_EMEFIELD_AUTOFILLED = 'WFP_SET_EMEFIELD_AUTOFILLED';
const REMOVE_EMEFIELD = 'WFP_REMOVE_EMEFIELD'
const CLEAR_ACCESSTOKEN_OPENID = 'WFP_CLEAR_ACCESSTOKEN_OPENID'
const CLEAR_EMESESSION = 'WFP_CLEAR_EMESESSION'

// Initial state with emeFieldStatus as an array
const initialState = {
    isLogin: false, 
	isUsingAppLogin: false, 
	useEME: false,
	accessToken: null,
	openID: null,
    emeFieldStatus: [],
};

// Action creators
export const directLoginStart = () => ({type: DIRECT_LOGIN_START});
export const directLoginSuccess = (data) => ({type:DIRECT_LOGIN_DONE, payload: data});
export const directLoginError = (err) => ({type: DIRECT_LOGIN_ERROR, payload: err});

export const getDirectLoginStatusStart = () => ({type: GET_DIRECT_LOGIN_RESULT_START});
export const getDirectLoginStatusSuccess = (data) => ({type:GET_DIRECT_LOGIN_RESULT_DONE, payload: data});
export const getDirectLoginStatusError = (err) => ({type: GET_DIRECT_LOGIN_RESULT_ERROR, payload: err});

export const setUseEME = (val) => ({ type: SET_USEEME, payload: val });
export const setIsUsingAppLogin = (val) => ({ type: SET_IS_USING_APP_LOGIN, payload: val });

export const setEMEFieldEdited = (fieldId) => ({
    type: SET_EMEFIELD_EDITED,
    payload: { fieldId },
});

export const markEMEFieldAutofilled = (fieldId) => ({
    type: SET_EMEFIELD_AUTOFILLED,
    payload: { fieldId },
});

export const removeEMEField = () => ({
    type: REMOVE_EMEFIELD
});

export const clearAccessTokenOpenID = () => ({
    type: CLEAR_ACCESSTOKEN_OPENID
})

export const clearEMESession = () => ({
    type: CLEAR_EMESESSION
})

// Reducer
export default (state = initialState, action) => { 
    switch (action.type) {
		case SET_USEEME:
			return { ...state, useEME: action.payload}
        case SET_IS_USING_APP_LOGIN:
            return { ...state, isUsingAppLogin: action.payload}

        case GET_DIRECT_LOGIN_RESULT_DONE:
        case DIRECT_LOGIN_DONE:
            return { ...state, accessToken: action.payload.accessToken, openID: action.payload.openID, isLogin: true };
        
        case SET_EMEFIELD_EDITED:
            return {
                ...state,
                emeFieldStatus: state.emeFieldStatus.map(field => 
                    field.fieldId === action.payload.fieldId
                        ? { ...field, edited: true, autofilled: false }
                        : field
                ),
            };
        
        case SET_EMEFIELD_AUTOFILLED:
            return {
                ...state,
                emeFieldStatus: updateFieldStatus(state.emeFieldStatus, action.payload.fieldId, true, false),
            };

        case REMOVE_EMEFIELD:
            return {
                ...state,
                emeFieldStatus: []
            };

        case CLEAR_ACCESSTOKEN_OPENID:
            return {
                ...state,
                accessToken: null,
                openID: null,
            };
        
        case CLEAR_EMESESSION:
            return {
                ...initialState
            };

        default:
            return state;
    }
};

// Helper function to update or add field status
const updateFieldStatus = (fields, fieldId, autofilled, edited) => {
    const existingField = fields.find(field => field.fieldId === fieldId);
    if (existingField) {
        return fields.map(field => 
            field.fieldId === fieldId 
                ? { ...existingField, autofilled, edited }
                : field
        );
    } else {
        return [...fields, { fieldId, autofilled, edited }];
    }
};